import React from 'react';
import { Card } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import ImportTab from './components/ImportTab';

const DefaultZipcodePickupHubPage: React.FC = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-7xl mx-auto">
                <div className="bg-white shadow-sm">
                    <div className="px-6 py-4 border-b border-gray-200">
                        <h1 className="text-2xl font-semibold text-gray-800">默认ZipCode揽收HUB配置</h1>
                        <p className="mt-1 text-sm text-gray-500">
                            管理默认ZipCode与揽收HUB的关联关系（兜底查询用），支持通过Excel文件批量导入配置
                        </p>
                    </div>

                    <div className="p-6">
                        <ImportTab />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DefaultZipcodePickupHubPage;
